<template>
  <div class="popup-box flex flex-column" style="position: relative">
    <ul class="form-box">
      <div
        style="
          background-color: #e6edf4;
          padding: 15px 10px;
          border-radius: 5px;
          font-size: 13px;
          color: rgba(0, 0, 0, 0.7);
        "
      >
        企业被申诉个人所得税扣缴申报任职受雇信息有误，请自行核实处理，并于限期反馈日前将核实结果反情给主管税务机关，逾期仍未反情的，税务机关将就该申诉事项实施调
        X 2022/03108 00:00:00查，请于前反馈申请信息。
      </div>
      <div
        style="
          font-weight: 600;
          font-size: 14px;
          padding-bottom: 10px;
          border-bottom: 1px solid #f0eded;
          margin-top: 10px;
        "
      >
        申诉信息
      </div>
      <table class="shensuguanli-detail-info" cellspacing="10">
        <tr>
          <td>限期反馈日期：</td>
          <td>{{ state.model?.xqfkrq || "-" }}</td>
          <td>申诉编号：</td>
          <td>{{ state.model?.xxxh || "-" }}</td>
          <td>扣缴义务人：</td>
          <td>{{ state.model?.withholding_agent_name || "-" }}</td>
          <td>税局：</td>
          <td>{{ state.model?.tax_bureau_name || "-" }}</td>
        </tr>
        <tr>
          <td>消息类型：</td>
          <td>{{ state.model?.xxlx || "-" }}</td>
          <td>申诉事项：</td>
          <td>{{ state.model?.sssxmc || "-" }}</td>
          <td>申诉人姓名：</td>
          <td>{{ state.model?.ssrxm || "-" }}</td>
          <td>申诉类型：</td>
          <td>{{ state.model?.sslxmc || "-" }}</td>
        </tr>
        <tr>
          <td>证件类型：</td>
          <td>{{ state.model?.ssrzzlx || "-" }}</td>
          <td>证件号码：</td>
          <td>{{ state.model?.ssrzzhm || "-" }}</td>
          <td>申诉日期：</td>
          <td>{{ state.model?.ssrq || "-" }}</td>
          <td>离职日期：</td>
          <td>{{ state.model?.lzrq || "-" }}</td>
        </tr>
        <tr>
          <td>补充说明：</td>
          <td :colspan="7">{{ state.model?.bcsm || "-" }}</td>
        </tr>
      </table>
      <template v-if="state.model.is_deal === 0">
        <div
          style="
            font-weight: 600;
            font-size: 14px;
            padding-bottom: 10px;
            border-bottom: 1px solid #f0eded;
            margin-top: 10px;
          "
        >
          请反馈一下任职受雇信息
        </div>
        <el-form
          :model="state.checkModel"
          label-width="auto"
          style="margin-top: 10px"
          ref="formDom"
        >
          <el-form-item
            label="自查处理结果"
            prop="zccljg"
            :rules="[
              {
                required: true,
                message: '请选择自查处理结果',
                trigger: 'blur',
              },
            ]"
          >
            <el-radio-group v-model="state.checkModel.zccljg">
              <el-radio value="0" style="color: #f00">申诉不属实</el-radio>
              <el-radio value="1" style="color: #1e90ff">申诉属实</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="自查处理证明">
            <div>
              <ul style="display: flex">
                <div
                  style="
                    width: 100px;
                    height: 100px;
                    border-radius: 5px;
                    margin-right: 10px;
                    overflow: hidden;
                    position: relative;
                  "
                  v-for="(item, index) in state.checkModel.files"
                  :key="item"
                  class="images-group-box"
                >
                  <el-image
                    :src="item.file_url"
                    style="width: 100%; height: 100%"
                  >
                  </el-image>
                  <li
                    style="
                      position: absolute;
                      width: 100%;
                      height: 100%;
                      top: 0;
                      left: 0;
                      background-color: rgba(0, 0, 0, 0.5);
                      z-index: 999;
                      display: none;
                      align-items: center;
                      justify-content: center;
                      cursor: pointer;
                    "
                    class="images-group-delete"
                  >
                    <el-icon
                      color="#fff"
                      size="20"
                      style="margin-right: 10px"
                      @click="
                        state.imageViewIndex = index;
                        state.showImageView = true;
                      "
                      ><View
                    /></el-icon>
                    <el-icon
                      color="#fff"
                      size="20"
                      @click="state.checkModel.files.splice(index, 1)"
                      ><Delete
                    /></el-icon>
                  </li>
                </div>
                <el-upload
                  :show-file-list="false"
                  :auto-upload="false"
                  :multiple="true"
                  :on-change="onChangeFile"
                  accept=".bmp,.jpeg,.jpg,.png"
                >
                  <template #trigger>
                    <li style="" class="shensuguanli-detail-upload">
                      <el-icon color="#fff" size="20"><Plus /></el-icon
                      ><text style="color: #fff; line-height: 20px">上传</text>
                    </li>
                  </template>
                </el-upload>
              </ul>
              <text style="color: #a2a2a2; font-size: 13px">
                请上传如《劳动合同》、花名册或其他相关证明材料，以便审核人员处理申诉。最多可上传5个文件，每个文件大小不能超过1M，支持BMP、jpeg、jpg、png格式.
              </text>
            </div>
          </el-form-item>
          <el-form-item
            label="反馈说明"
            prop="fksm"
            :rules="[
              { required: true, message: '请填写反馈说明', trigger: 'blur' },
            ]"
            style="width: 50%"
          >
            <el-input type="textarea" v-model="state.checkModel.fksm" />
          </el-form-item>
          <ul style="width: 50%; display: flex">
            <el-form-item label="反馈人" style="width: 50%">
              <el-input v-model="state.checkModel.fkrxm" />
            </el-form-item>
            <el-form-item label="联系电话" style="width: 50%">
              <el-input v-model="state.checkModel.fkrlxfs" />
            </el-form-item>
          </ul>
        </el-form>
      </template>
      <template v-else>
        <div
          style="
            font-weight: 600;
            font-size: 14px;
            padding-bottom: 10px;
            border-bottom: 1px solid #f0eded;
            margin-top: 10px;
          "
        >
          处理信息
        </div>
        <el-form
          :model="state.checkModel"
          label-width="auto"
          style="margin-top: 10px"
          ref="formDom"
        >
          <el-form-item label="处理状态">
            <text v-if="state.model.status == 0">待处理</text>
            <text style="color: #080" v-else>已处理</text>
          </el-form-item>
          <el-form-item label="自查处理结果">
            <template v-if="state.model.zccljg != null">
              <text style="color: #f00" v-if="state.model.zccljg == 0">
                申诉不属实
              </text>
              <text style="color: #1e90ff" v-else>申诉属实</text>
            </template>
            <text>-</text>
          </el-form-item>
          <el-form-item label="自查处理证明">
            <div
              style="display: flex"
              v-if="state.model?.attachment?.length > 0"
            >
              <el-image
                v-for="item in state.model.attachment"
                :key="item"
                :src="item.file_url"
                style="
                  width: 100px;
                  height: 100px;
                  border-radius: 5px;
                  margin-right: 10px;
                "
                hide-on-click-modal
                :preview-src-list="
                  state.model.attachment?.map((m) => m.file_url)
                "
              >
              </el-image>
            </div>
            <text v-else>-</text>
          </el-form-item>
          <el-form-item
            label="反馈说明"
            prop="fksm"
            :rules="[
              { required: true, message: '请填写反馈说明', trigger: 'blur' },
            ]"
            style="width: 50%"
          >
            <div v-html="state.model.fksm || '-'"></div>
          </el-form-item>
          <ul style="width: 50%; display: flex">
            <el-form-item label="反馈人" style="width: 50%">
              <div v-html="state.model.fkrxm || '-'" />
            </el-form-item>
            <el-form-item label="联系电话" style="width: 50%">
              <div v-html="state.model.fkrlxfs || '-'" />
            </el-form-item>
          </ul>
        </el-form>
      </template>
    </ul>
    <ul class="submit-box" v-if="state.model.is_deal === 0">
      <el-button type="primary" @click="onSubmit">提交</el-button>
    </ul>
    <el-image-viewer
      @close="state.showImageView = false"
      :url-list="state.checkModel.files.map((m) => m.file_url)"
      :initial-index="state.imageViewIndex"
      hide-on-click-modal
      :infinite="false"
      v-if="state.showImageView"
    />
  </div>
</template>

<script>
import { onMounted, reactive, ref } from "vue";
import { ptsmessage_detail, ptsmessage_check } from "@/http/ptsmessage";
import { attachment_upload } from "@/http/attachment";
import { ElMessage } from "element-plus";
import store from "@/store";
export default {
  props: {
    id: Number,
  },
  setup(props) {
    const formDom = ref(null);
    const imageDom = ref(null);
    const state = reactive({
      model: {},
      checkModel: {
        files: [],
      },
    });
    onMounted(() => {
      state.checkModel.fkrxm = store.state.loginUser?.name;
      onLoad();
    });

    const onLoad = () => {
      ptsmessage_detail(props.id).then((res) => {
        if (res.status == 200) {
          state.model = res.data.data;
          if (state.model.is_deal === 0 && !state.checkModel.fkrlxfs) {
            state.checkModel.fkrlxfs = "18655162361";
          }
        }
      });
    };

    const onChangeFile = (file) => {
      const formData = new FormData();
      formData.append("file[]", file.raw);
      attachment_upload(formData).then((res) => {
        if (res.status == 200) {
          res.data.data.forEach((e) => {
            state.checkModel.files.push(e);
          });
        }
      });
    };

    const onShowImageView = () => {
      imageDom.value.clickHandler();
    };

    const onSubmit = () => {
      formDom.value.validate((valid) => {
        if (valid) {
          const data = {
            id: props.id,
            zccljg: state.checkModel.zccljg,
            fksm: state.checkModel.fksm,
            fkrxm: state.checkModel.fkrxm,
            fkrlxfs: state.checkModel.fkrlxfs,
            wjlb: state.checkModel.files.map((m) => m.id).join(","),
          };
          ptsmessage_check(data).then((res) => {
            if (res.status == 200) {
              ElMessage.success(res.data.msg);
            }
          });
        }
      });
    };
    return {
      state,
      onChangeFile,
      onShowImageView,
      imageDom,
      formDom,
      onSubmit,
    };
  },
};
</script>
<style scoped lang="less">
.shensuguanli-detail-info {
  width: 100%;
  color: rgba(0, 0, 0, 0.7);
  font-size: 14px;

  & td:first-child {
    width: 120px;
  }

  & td:nth-child(2n + 1) {
    text-align: right;
    color: #aaaaaa;
  }
}
.shensuguanli-detail-upload {
  width: 100px;
  height: 100px;
  border: 1px dashed #fff;
  background-color: #d7d7d7;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  cursor: pointer;

  &:hover {
    background-color: #858585;
  }
}

.images-group-box {
  &:hover .images-group-delete {
    display: flex !important;
  }
}
</style>
